<template>
  <div>
    <template v-if="!areCardsDisabled">
      <v-layout row wrap>
        <v-flex
          xs12 sm6 md6 lg3 xl3 
          style="padding: 12px"
          v-if="card.enabled"
          :key="index"
          v-for="(card, index) in cards"
        >
          <card-template
            :id="'carditem0'"
            :card="card"
            :is-loading="isLoadingDistributors"
          ></card-template>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-container>
        <v-layout wrap>
          <v-flex style="color:white;font-weight:500;" class="align-center layout">
            No hay tarjetas habilitadas. 
            <template v-if="!isAdmin">Consulte con el administradaaor.</template>
            <template v-else>
              <v-btn
                depressed dark rounded
                class="strategio-card-button prim"
                @click="listCards"
                :loading="isLoadingCards"
              >
                Habilitar
              </v-btn>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </div>
</template>

<script>
import {filter} from 'lodash'

import eventBus from '../../utils/eventBus'
import cardsStorage from './../../storage/cardsStorage'
import CardTemplate from './card-template.vue'

export default {
  data () {
    return {
      cards: [],
      isAdmin: true
    }
  },
  mounted () {
    this.cards = cardsStorage.getCardsPointer().cards
  },
  methods: {
    listCards () {
      // emit to: /components/dialogs/show-cards-dialog.vue
      eventBus.$emit('open-show-cards-dialog', this.cards)
    }
  },
  computed: {
    isLoadingCards () {
      return !cardsStorage.getCardsPointer().requestFinished
    },
    areCardsDisabled () {
      return filter(this.cards, (card) => card.enabled).length === 0
    }/* ,
    cardsInfo () {
      return [
        {
          cardType: 'VALIDATOR',
          cardInfo: () => {
            return {
              lightColor: 'red',
              cardNumber: '99+',
              message: 'No definido'
            }
          },
          cardDetails: {
            title: 'Título no definido',
            message: 'Mensaje no definido',
            body: {
              card: [
                {
                  color: '',
                  description: 'No definido'
                }
              ],
              detail: [
                {
                  color: '',
                  description: 'No definido'
                }
              ]
            }
          }
        },
        {
          cardType: 'REMOTE FILES',
          cardInfo: () => {
            const outdated = supervisorStorage.getOutDatedFtpFiles()
            const updated = supervisorStorage.getUpdatedFtpFiles()
            const total = updated + outdated

            const percentageUpdated = updated / total
            // const percentageOutDated = outdated / total
            if (this.isLoading) {
              return {
                lightColor: 'gray',
                cardNumber: outdated,
                message: 'Verificando archivos'
              }
            }
            if (total === updated) { // to avoid undefined trap, do not use percetageUpdated === 1
              return {
                lightColor: 'green',
                cardNumber: 0,
                message: 'Todos los distribuidora(s) enviaron sus archivos'
              }
            }
            if (percentageUpdated > 0.9) {
              return {
                lightColor: 'amber',
                cardNumber: outdated,
                message: `de ${total} distribuidora(s) no ha enviado sus archivos`
              }
            }
            return {
              lightColor: 'red',
              cardNumber: outdated,
              message: `de ${total} distribuidora(s) no ha enviado sus archivos`
            }
          },
          cardDetails: {
            title: `Título para 'Archivos FTP'`,
            message: ``,
            body: {
              card: [
                {
                  color: 'green',
                  description: 'El 100% de distribuidoras envió sus archivos a la fecha'
                },
                {
                  color: 'amber',
                  description: 'Al menos 90% de distribuidoras envió sus achivos a la fecha'
                },
                {
                  color: 'red',
                  description: 'Menos del 90% de distribuidoras envió sus archivos a la fecha'
                }
              ],
              detail: [
                {
                  color: 'green',
                  description: 'Archivos no están fuera de fecha'
                },
                {
                  color: 'amber',
                  description: 'Archivos tienen hasta 2 días de antiguedad'
                },
                {
                  color: 'red',
                  description: 'Archivos tienen más de 2 días de antiguiedad'
                },
                {
                  color: 'red lighten-2',
                  description: 'No se encontraron archivos'
                }
              ]
            }
          }
        },
        {
          cardType: 'CONSISTENCIES',
          cardInfo: () => {
            const consistent = supervisorStorage.getConsistencyCorrectLogs()
            const total = supervisorStorage.getSupervisorFtpFiles().length
            const inconsistent = total - consistent

            const percentageConsistency = consistent / total
            if (this.isLoading) {
              return {
                lightColor: 'gray',
                cardNumber: 0,
                message: 'Verificando archivos'
              }
            }
            if (total === consistent) {
              return {
                lightColor: 'green',
                cardNumber: 0,
                message: 'Correcto, todos los archivos son consistentes'
              }
            }
            if (percentageConsistency > 0.9) {
              return {
                lightColor: 'amber',
                cardNumber: inconsistent,
                message: `de ${total} distribuidora(s) tiene archivos inconsistentes`
              }
            }
            return {
              lightColor: 'red',
              cardNumber: inconsistent,
              message: `de ${total} distribuidora(s) tiene archivos inconsistentes`
            }
          },
          cardDetails: {
            title: 'Título no definido',
            message: ``,
            body: {
              card: [
                {
                  color: 'green',
                  description: 'El 100% de distribuidoras tiene archivos consistentes'
                },
                {
                  color: 'amber',
                  description: 'Al menos 90% de distribuidoras tiene archivos consistentes'
                },
                {
                  color: 'red',
                  description: 'Menos del 90% de distribuidoras tiene archivos consistentes'
                }
              ],
              detail: [
                {
                  color: 'green',
                  description: 'Logs no contienen errores ni filas removidas'
                },
                {
                  color: 'amber',
                  description: 'Como máximo, el 10% de logs tiene errores pero no filas removidas'
                },
                {
                  color: 'red',
                  description: 'Más del 10% de logs tiene errores o filas removidas, o está fuera de fecha'
                },
                {
                  color: 'red lighten-2',
                  description: 'No se encontraron logs o no se los puede leer'
                }
              ]
            }
          }
        },
        {
          cardType: 'DATABASE',
          cardInfo: () => {
            const correct = supervisorStorage.getDatabaseCorrectLogs()
            const total = supervisorStorage.getSupervisorFtpFiles().length
            const incorrect = total - correct

            const percentageCorrect = correct / total
            if (this.isLoading) {
              return {
                lightColor: 'gray',
                cardNumber: 0,
                message: 'Verificando archivos'
              }
            }
            if (total === correct) {
              return {
                lightColor: 'green',
                cardNumber: 0,
                message: 'Correcto, ninguna distribuidora tiene errores en su BD'
              }
            } else if (percentageCorrect > 0.9) {
              return {
                lightColor: 'amber',
                cardNumber: incorrect,
                message: `de ${total} distribuidora(s) tiene errores en su BD`
              }
            } else {
              return {
                lightColor: 'red',
                cardNumber: incorrect,
                message: `de ${total} distribuidora(s) tiene errores en su BD`
              }
            }
          },
          cardDetails: {
            title: 'Título no definido',
            message: ``,
            body: {
              card: [
                {
                  color: 'green',
                  description: 'El 100% de distribuidoras no tiene errores en la base de datos'
                },
                {
                  color: 'amber',
                  description: 'Al menos 90% de distribuidoras no tiene errores en la base de datos'
                },
                {
                  color: 'red',
                  description: 'Menos del 90% de distribuidoras no tiene errores en la base de datos'
                }
              ],
              detail: [
                {
                  color: 'green',
                  description: 'Datos de ventas tienen, como máximo, 1 día de antiguedad y están al día'
                },
                {
                  color: 'amber',
                  description: 'Datos de ventas tienen, como máximo, 2 días de antiguedad'
                },
                {
                  color: 'red',
                  description: 'Datos de ventas tienen más de 2 días de antiguedad'
                }
              ]
            }
          }
        },
        {
          cardType: 'REPORTS GENERATOR',
          cardInfo: () => {
            return {
              lightColor: 'red',
              cardNumber: '99+',
              message: 'Errores y advertencias al generar reportes'
            }
          },
          cardDetails: {
            title: 'Título no definido',
            message: 'Mensaje no definido',
            body: {
              card: [
                {
                  color: '',
                  description: 'No definido'
                }
              ],
              detail: [
                {
                  color: '',
                  description: 'No definido'
                }
              ]
            }
          }
        },
        {
          cardType: 'SHIPPING CONTROL',
          cardInfo: () => {
            return {
              lightColor: 'red',
              cardNumber: '99+',
              message: 'No definido'
            }
          },
          cardDetails: {
            title: 'Título no definido',
            message: 'Mensaje no definido',
            body: {
              card: [
                {
                  color: '',
                  description: 'No definido'
                }
              ],
              detail: [
                {
                  color: '',
                  description: 'No definido'
                }
              ]
            }
          }
        }
      ]
    } */
  },
  props: {
    isLoadingDistributors: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  components: {
    CardTemplate
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/cards-list.vue